<template>
    <div class="single--event--root">
  
      <div class="ui fluid card">
        <div class="content">
          <div class="header">
            Training
            <span class="ui green tag label">
              <i class="check icon"></i>
              You are registered to this course
            </span>
          </div>
          <div class="meta">
            <span class="date">
              {{ event.post_date }}
            </span>
          </div>
        </div>
        <div class="content">
          <table class="ui very basic table">
            <tbody>
              <tr>
                <td>Title</td>
                <td>
                  <h4 class="ui header">
                    {{ event.post_title }}
                  </h4>
                </td>
              </tr>
              <tr>
                <td>Logo</td>
                <td>
                  <img :src="event.event_logo" class="ui small rounded image">
                </td>
              </tr>
              <tr>
                <td>Banner</td>
                <td>
                  <img :src="event.featured_image" class="ui  image">
                </td>
              </tr>
              <tr v-if="post_content">
                <td>Description</td>
                <td>
                  {{ post_content }}
                </td>
              </tr>
              <tr>
                <td>Start Date</td>
                <td>
                  {{ event.start_date }}
                </td>
              </tr>
              <tr>
                <td>End Date</td>
                <td>
                  {{ event.end_date }}
                </td>
              </tr>
              <tr>
                <td>Start Time</td>
                <td>
                  {{ event.start_time }}
                </td>
              </tr>
              <tr>
                <td>End Time</td>
                <td>
                  {{ event.end_time }}
                </td>
              </tr>
              <tr>
                <td>Location</td>
                <td>
                  <div class="ui labels">
                    <span class="ui label" v-for="(loc, i) in event.location" :key="i">
                      {{ loc.name }}
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Organizer</td>
                <td>
                  <div>
                    <div class="ui label">
                      {{ event.organizer[0].name }}
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Category</td>
                <td>
                  <div class="ui labels">
                    <span class="ui label" v-for="(cat, i) in event.category" :key="i">
                      {{ cat.name }}
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Speakers</td>
                <td>
                  <div class="ui cards">
                    <div class="purple card" v-for="(speaker, i) in event.speakers" :key="i">
                      <div class="content">
  
                        <div class="header">
                          {{ speaker.speaker.speaker_info.name }}
                          <img :src="speaker.speaker.speaker_info.image" class="ui avatar image" v-if="speaker.speaker.speaker_info.image">
                          <p class="ui sub header">
                            {{ speaker.speaker.speaker_info.job_title }}
                          </p>
                        </div>
                        <div class="description">
                          <div class="extra">
                            <div class="ui label" v-show="speaker.speaker.social.facebook_url">
                              <i class="facebook icon"></i>
                              {{ speaker.speaker.social.facebook_url }}
                            </div>
                            <div class="ui label" v-show="speaker.speaker.social.linkedin_url">
                              <i class="linkedin icon"></i>
                              {{ speaker.speaker.social.linkedin_url }}
                            </div>
                            <div class="ui label" v-show="speaker.speaker.social.twitter_url">
                              <i class="twitter icon"></i>
                              {{ speaker.speaker.social.twitter_url }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Agendas</td>
                <td>
                  <sui-tab>
                    <sui-tab-pane v-for="(ag, i) in event.agendas" :title="ag.day.day_title + ' - ' + ag.day.date" :key="i">
                      <h3>{{ag.day.day_title}}</h3>
                      <span>
                        {{ag.day.date}}
                      </span>
                      <div class="ui cards">
                        <div class="card ag--card" v-for="(agenda, i) in ag.day.agenda" :key="i">
                          <div class="content">
                            <div class="header">
                              {{ agenda.title }}
                            </div>
                            <div class="meta">
                              <span class="date">
                                {{ agenda.time_range.start_at }} - {{ agenda.time_range.end_at }}
                              </span>
                            </div>
                            <div class="description" v-if="agenda.description">
                              <p>{{ agenda.description }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </sui-tab-pane>
                  </sui-tab>
                </td>
              </tr>
          
            </tbody>
          </table>
        </div>
        <div class="extra content">

          <button class="ui negative button" @click="unregisterTraining(event.ID)">
            Unregister <i class="window close outline icon"></i>
          </button>
        </div>
      </div>
  
      <sui-modal v-model="deleteModal">
        <sui-modal-header>
          <h3>Delete Event</h3>
        </sui-modal-header>
        <sui-modal-content >
          <sui-modal-description>
            <sui-header>
              Do you want to delete 
              {{ event.post_title }}
              event?
            </sui-header>
            <p>
              You will not be able to recover this event.
            </p>
          </sui-modal-description>
        </sui-modal-content>
        <sui-modal-actions>
          <button class="ui negative button" @click="deleteEvent">
            <i class="trash icon"></i>
            Delete
          </button>
          <button class="ui button" @click="toggle">
            <i class="close icon"></i>
            Cancel
          </button>
        </sui-modal-actions>
      </sui-modal>
    </div>
  </template>
   
  <script>
  export default {
    name: 'SingleCourse',
    data() {
      return {
        event: {},
        post_content: '',
        deleteModal: false,
        authToken: localStorage.getItem('sjdifjsckdsjfosdf54520bearer')
      };
    },
    methods: {
      toggle() {
        this.deleteModal = !this.deleteModal;
      },
      stripTags(input) {
        // A method to strip HTML tags from input
        const doc = new DOMParser().parseFromString(input, 'text/html');
        return doc.body.textContent || '';
      },
      async fetchEvent() {
        try {
          const response = await fetch('/wp-json/custom/v1/my-training/' + this.$route.params.id + '?k__sjnb__sdfjn0547=' + localStorage.getItem('sjdifjsckdsjfosdf54520zzz') + '', {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            },
          });
  
          const responseData = await response.json();
  
          if (response.ok && responseData.success) {
            this.event = responseData.training;
            this.post_content = this.stripTags(this.event.post_content);
            localStorage.setItem('cn_t_nt', this.event.post_content);
          } else {
            console.error('Failed to fetch event:', responseData);
          }
        } catch (error) {
          console.error('An error occurred:', error);
        }
      },
      async deleteEvent() {
        try {
          const response = await fetch('/wp-json/wp/v2/event/'+this.event.ID+'', {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${this.authToken}`,
            },
          });
  
          if (response.ok ) {
              console.log('Resource deleted');
              this.$router.push('/dashboard/events');
            } else {
              console.error('Failed to delete resource');
            }
          } catch (error) {
            console.error('An error occurred:', error);
          }
      },
      unregisterTraining (id) {
        fetch('/wp-json/custom/v1/unregister-training/'+ id, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            k__sjnb__sdfjn0547: localStorage.getItem('sjdifjsckdsjfosdf54520zzz'),
            training_id: id,
          })
        }).then(response => response.json())
          .then(data => {
            console.log(data);
            if (data.success) {
              // push to courses page
                this.$router.push('/dashboard/courses');
            }
          })
          .catch(error => {
            console.error('An error occurred:', error);
          });
      }
    },
    created() {
      this.fetchEvent();
    },
  }
  </script>
  
  <style lang="sass" scoped>
    .single--event--root
      .extra
        .label
          margin: 5px

      .card.ag--card
        width: 100% !important
  </style>
  